import { ReactElement } from 'react';
import type { Activity } from 'types';

export function ActivityTitle({ name }: Activity): ReactElement {
  return <div>{name}</div>;
}
